export default {"src":"/_next/static/media/huutokaupat-full-white.a065b552.svg","height":340,"width":1753,"blurWidth":0,"blurHeight":0};